// src/services/api/offlineSales/quotations.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/quotation.routes.js
// (no delete endpoint exists on the backend, so no deleteQuotation here)
import { apiClient } from '../base';

export const getQuotations = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/quotations', { params });
  return response.data;
};

export const getQuotation = async (quotationId) => {
  const response = await apiClient.get(`/offline-sales/quotations/${quotationId}`);
  return response.data;
};

export const createQuotation = async (data) => {
  const response = await apiClient.post('/offline-sales/quotations', data);
  return response.data;
};

export const updateQuotation = async (quotationId, data) => {
  const response = await apiClient.put(`/offline-sales/quotations/${quotationId}`, data);
  return response.data;
};

export const convertQuotation = async (quotationId, data = {}) => {
  const response = await apiClient.post(`/offline-sales/quotations/${quotationId}/convert`, data);
  return response.data;
};
